import config from '../config';
import { log } from '../helpers';

export default function event(payload) {
  if (!payload) return;
  if (typeof payload != 'object') {
    log(`Expected payload of type 'object' but received '${typeof payload}'.`);
    return;
  }

  config.ANALYTICS_SERVICE.postAnalyticsEvent([
    {
      ...payload,
      timestamp: Date.now(),
    },
  ]);
}
